import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d0c7d36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "标题：", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "block-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "创建人：", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "block-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "创建日期：", -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "block-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "备注：", -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "附件：")
], -1))
const _hoisted_16 = { class: "block-row" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.infodata.title), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.infodata.createName), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.infodata.createDate), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.infodata.remark), 1)
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.files, (li, i) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "files",
            src: li.url,
            key: i
          }, null, 8, _hoisted_17))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      "z-index": "2000",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"width":"100%"}
          }, null, 8, _hoisted_19)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}